import { ISkills } from '../interfaces/Skills';

export const SkillsData: ISkills[] = [
  {
    title: 'Back-End',
    skills: [
      {
        grid: 'col s6 m4',
        src: 'images/nodejs.png',
        name: 'Nodejs',
      },
      {
        grid: 'col s12 m4',
        src: 'images/nestjs_128.png',
        name: 'Nestjs',
      },
      {
        grid: 'col s6 m4',
        src: 'images/expressjs_128.png',
        name: 'Express.js',
      },
      {
        grid: 'col s6 m4',
        src: 'images/postgresql.png',
        name: 'PostgreSQL',
      },
      {
        grid: 'col s6 m4',
        src: 'images/mongodb.png',
        name: 'MongoDB',
      },
      {
        grid: 'col s6 m4',
        src: 'images/rabbitmq_icon_128x128.png',
        name: 'RabbitMQ',
      },
    ],
  },
  {
    title: 'Javascript TypeScript',
    skills: [
      {
        grid: 'col s6 m4',
        src: 'images/javascript.png',
        name: 'Javascript',
      },
      {
        grid: 'col s6 m4',
        src: 'images/typescript_128.png',
        name: 'TypeScript',
      },
      {
        grid: 'col s6 m4',
        src: 'images/react.png',
        name: 'React',
      },
    ],
  },
  {
    title: 'HTML',
    skills: [
      {
        grid: 'col s6 m6',
        src: 'images/html5.png',
        name: 'HTML5',
      },
      {
        grid: 'col s6 m6',
        src: 'images/react.png',
        name: 'JSX',
      },
    ],
  },
  {
    title: 'CSS',
    skills: [
      {
        grid: 'col s6',
        src: 'images/css3.png',
        name: 'CSS3',
      },
      {
        grid: 'col s6',
        src: 'images/materialize.png',
        name: 'Materialize',
      },
    ],
  },
  {
    title: 'Other',
    skills: [
      {
        grid: 'col s6 m4',
        src: 'images/github.png',
        name: 'Github',
      },
      {
        grid: 'col s6 m4',
        src: 'images/linux.png',
        name: 'linux',
      },
      {
        grid: 'col s6 m4',
        src: 'images/nginx.png',
        name: 'Nginx',
      },
      {
        grid: 'col s6 m4',
        src: 'images/vscode.png',
        name: 'VSCode',
      },
      {
        grid: 'col s12 m4',
        src: 'images/swagger_128px.png',
        name: 'Swagger',
      },
      {
        grid: 'col s12 m4',
        src: 'images/gitlab_128x128.png',
        name: 'GitLab',
      },
    ],
  },
];
